module.exports = __webpack_public_path__ + "static/media/Lords_Mobile_logo.488f87e5.png";